import type { ProjectTag } from '@containers/projects/types';

export const parseProjectTags = (tags: ProjectTag[]): ProjectTag[] =>
  tags.filter(({ key, value }) => key?.trim() && value?.trim()).map(({ id, key, value }) => ({ id, key, value }));
